<template>
  <el-dialog :append-to-body="true" title="创建头像昵称及跳转页" :visible.sync="showAddProfileModal" width="500px">
    <el-form ref="add-profile-form" :rules="profileFormRules" :model="profileForm" label-width="80px">
      <el-form-item label="头像" prop="url">
        <el-upload class="avatar-uploader" action="#" ref="upload" :show-file-list="false" :before-upload="beforeAvatarUpload">
          <img v-if="profileForm.url" :src="profileForm.url" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <p style="font-size: 12px">格式支持 PNG/JPG 宽高比为1:1 尺寸不超过512px 大小不超过50KB</p>
      </el-form-item>
      <el-form-item label="昵称" prop="profile_name">
        <el-input v-model="profileForm.profile_name" placeholder="1-30个字符，中文占2个字符"></el-input>
      </el-form-item>
      <el-form-item label="简介" prop="description">
        <el-input v-model="profileForm.description" rows="3" type="textarea" placeholder="1-240个字符，中文占2个字符"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onModalClose">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="onProfileUploadSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addProfiles } from '@/api/tencent.local.model'
export default {
  props: ['value', 'accountId', 'promotedObjectId'],
  data() {
    return {
      submitLoading: false,
      profileBinary: null,

      profileForm: {
        profile_name: '',
        description: '',
        url: ''
      },
      profileFormRules: {
        profile_name: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        description: [{ required: true, message: '请输入简介', trigger: 'blur' }],
        url: [{ required: true, message: '请上传头像', trigger: 'change' }]
      }
    }
  },
  computed: {
    showAddProfileModal: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    onProfileUploadSubmit() {
      this.$refs['add-profile-form'].validate((valid) => {
        if (valid) {
          const { profile_name, description } = this.profileForm
          const { accountId, promotedObjectId } = this
          this.submitLoading = true
          addProfiles({
            ad_account_id: accountId,
            promoted_object_id: promotedObjectId,
            profile_name,
            description,
            file: this.profileBinary
          })
            .then((data) => {
              if (data) {
                this.$emit('add-confirm')
              }
              this.submitLoading = this.showAddProfileModal = false
            })
            .catch(() => {
              this.submitLoading = false
            })
        }
      })
    },
    onModalClose() {
      this.showAddProfileModal = false
      this.$refs['add-profile-form'].clearValidate()
    },
    beforeAvatarUpload(file) {
      const isValidType = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type)
      // 不能大于300kb
      const isValidSize = file.size < 1024 * 50

      if (!isValidType) {
        return this.$message.error('上传头像图片只能是JPG、PNG格式')
      }
      if (!isValidSize) {
        return this.$message.error('上传头像图片大小不能超过50KB')
      }

      this.profileBinary = file
      this.profileForm.url = URL.createObjectURL(file)

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-uploader {
  ::v-deep .el-upload {
    border: 1px dashed #c7c7c7;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .el-upload:hover {
    border-color: #409eff;
  }

  .avatar {
    width: 98px;
    height: 98px;
    display: block;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 98px;
    height: 98px;
    line-height: 98px;
    text-align: center;
  }
}
</style>
